<template>
    <Progressbar v-if="loading" />
    <NetworkError v-else-if="errors" @tryAgain="getData" />
    <div class="flex flex-row gap-6 w-full h-full" v-else>
        <div class="flex flex-1 flex-col overflow-hidden">
            <div class="flex items-center">
                <div class="alert bg-green-custom-1 text-green-custom-2 h-8 lg:h-12 py-0 px-2 md:px-4 relative">
                    <button :title="__('Back')"
                        class="btn btn-sm btn-outline border-none hover:bg-gray-300 btn-circle absolute right-0"
                        v-if="categoryParents.length" @click="backButton">
                        <ArrowSmallRightIcon class="w-5 h-5 text-black" />
                    </button>
                    <span class="mx-auto !my-1"> {{ getTitle() }}</span>
                </div>
            </div>
            <NotFound v-if="!values()?.length" />
            <div class="card bg-base-200">
                <div class="card-body px-2 py-4 md:p-4">
                    <div class="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-1 md:gap-5 items-baseline">
                        <button class="cursor-pointer hover:bg-gray-100/40 hover:rounded-lg relative"
                            @click="setCategory(category)" v-for="category in values()" v-show="!category?.hidden">
                            <img :src="category.image" class="w-16 h-16 m-auto" alt="image" />
                            <p class="text-center mt-1 text-sm text-black">{{ category.title }}</p>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <LeftSidebar :large="true" />
    </div>

</template>
<script setup>
import { computed, onMounted, onUpdated, watch, ref } from 'vue';
import LeftSidebar from "../layout/LeftSidebar.vue";
import useProducts from "../../../composables/shop/product";
import {
    ArrowSmallRightIcon,
} from '@heroicons/vue/24/outline'
const { errors, loading, categories, brands, cars, getCategories, route, router } = useProducts();
const categoryParents = ref([]);
const getData = () => {
    getCategories(route.params.type || 'primary', false, false);
};
watch(() => route.params.type, (type) => {
    const title = document.title.split(' - ')[0];
    document.title = window.i18n[(type.capitalize() || 'Categorie') + 's'] + ' | ' + title;
});
const getTitle = () => {
    let title = route.params.type;
    console.log(title);
    
    if(!title) title = window.i18n['Categories'];
    else if(!['brand','car'].includes(title)) title = window.i18n['Categories'];
    else title = window.i18n[title.capitalize() + 's'];
    return title;
}
const values = () => {
    const type = route.params.type;
    const data = ref([]);
    if (type == 'brand') data.value = brands.value;
    else if (type == 'car') data.value = cars.value;
    else if (categoryParents.value.length) {
        const parent = categoryParents.value[categoryParents.value.length - 1];
        data.value = parent?.children;
    } else data.value = categories.value;
    return data.value;
}

const backButton = () => categoryParents.value.pop();

const setCategory = (category) => {
    if (category.children?.length) {
        categoryParents.value.push(category);
    } else {
        const name = ['brand','car'].includes(route.params.type) ? route.params.type : 'category';
        const query = { [name]: category.id };
        router.push({ name: 'product', query: query });
    }
}

onMounted(() => {
    getData()
});
</script>